import { z } from 'zod';
import { BaseFacilityDTOSchema, } from "./facilities.dto.js";
export const FindFacilityBySlugRequestDTOSchema = z.object({
    params: z.object({
        companyId: BaseFacilityDTOSchema.shape.companyId,
        slug: z.string().min(1),
    }),
});
//# sourceMappingURL=find-facility-by-slug.dto.js.map